export const hasUrlParameter = (param: string) =>
  new URL(window.location.href).searchParams.has(param);

export const hasResponsiveUrlParameter = () => hasUrlParameter("responsive");
